module.exports = __webpack_public_path__ + "e281b6cf.svg";